class CustomScrollbar {
  constructor(root) {
    this.root = root instanceof Element ? root : document.querySelector(root);

    if (!this.root || this.root.dataset.customScrollbarInited === '1') {
      return;
    }

    this.setup();
    this.root.dataset.customScrollbarInited = '1';
  }

  setup() {
    let scroll = this.root.querySelector('.c-form-privacy__scroll');

    if (!scroll) {
      scroll = document.createElement('div');
      scroll.className = 'c-form-privacy__scroll';

      while (this.root.firstChild) {
        scroll.appendChild(this.root.firstChild);
      }

      this.root.appendChild(scroll);
    }

    this.scroll = scroll;

    let track = this.root.querySelector('.c-form-privacy__scrollbar');

    if (!track) {
      track = document.createElement('div');
      track.className = 'c-form-privacy__scrollbar';
      track.setAttribute('aria-hidden', 'true');

      const thumb = document.createElement('span');
      thumb.className = 'c-form-privacy__scrollbar-thumb';
      track.appendChild(thumb);

      this.root.appendChild(track);
    }

    this.track = track;
    this.thumb = track.querySelector('.c-form-privacy__scrollbar-thumb');

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.scroll.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (window.ResizeObserver) {
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.scroll);
    }

    this.update();
  }

  onScroll() {
    this.update();
  }

  onResize() {
    this.update();
  }

  update() {
    const { scrollHeight, clientHeight, scrollTop } = this.scroll;
    const hasOverflow = scrollHeight > clientHeight + 1;

    this.root.classList.toggle('is-scrollable', hasOverflow);
    this.root.classList.toggle('is-at-top', scrollTop <= 1);
    this.root.classList.toggle(
      'is-at-bottom',
      scrollTop + clientHeight >= scrollHeight - 1
    );

    if (!hasOverflow || !this.thumb || !this.track) {
      return;
    }

    if (!window.matchMedia('(max-width: 767px)').matches) {
      return;
    }

    const trackHeight = this.track.clientHeight;
    const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 24);
    const maxThumbTop = Math.max(trackHeight - thumbHeight, 0);
    const scrollRatio =
      scrollHeight - clientHeight > 0 ? scrollTop / (scrollHeight - clientHeight) : 0;
    const thumbTop = maxThumbTop * scrollRatio;

    this.thumb.style.height = `${thumbHeight}px`;
    this.thumb.style.transform = `translateY(${thumbTop}px)`;
  }
}
